import fileDownload from 'js-file-download';

// url
const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3991/crear'
  : 'https://pdf.sideop.com/crear';

export default {
  methods: {
    async mixGenerarPdf(data, nombreArchivo = 'archivo-sideop') {
      await this.axios.post(
        BASE_URL,
        data,
        { responseType: 'blob', timeout: 300000 },
      )
        .then((res) => {
          fileDownload(res.data, `${nombreArchivo}.pdf`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
    },
  },
};
